import src from "IMAGE";
export default { src, width: 5334, height: 2047, blurWidth: 0, blurHeight: 0};
